/**
 * menu-item-label.js
 */

import React from 'react';
import { Typography } from '@mui/material';


import makeStyles from '@mui/styles/makeStyles';


const useStyles = makeStyles(theme => ({
  root: {
    justifyContent: 'space-between',
  },
  exerciseName: {
    lineHeight: 1.3,
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  statusIcons: {
    '& > *': {
      margin: `0 ${theme.spacing(0.25)}`
    }
  },
}));

export default function MenuItemLabel(props) {
  const {
    text,
    statusIcons
  } = props;
  const classes = useStyles();

  return (
    <div className={`flex-hc ${classes.root}`}>
      <Typography variant="body2" className={classes.exerciseName}>
        {text}
      </Typography>

      <div className={`flex-hc ${classes.statusIcons}`}>
        {statusIcons}
      </div>
    </div>
  );
}